import { lazy } from 'react';

import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const Log = Loadable(lazy(() => import('views/Log')));
const UserPricing = Loadable(lazy(() => import('views/Pricing/UserPricing')));
const Token = Loadable(lazy(() => import('views/Token')));
const Topup = Loadable(lazy(() => import('views/Topup')));
const Profile = Loadable(lazy(() => import('views/Profile')));
const SystemVoices = Loadable(lazy(() => import('views/SystemVoices')));
const Dashboard = Loadable(lazy(() => import('views/Dashboard')));
const NotFoundView = Loadable(lazy(() => import('views/Error')));

const PanelRoutes = {
  path: '/panel',
  element: <MainLayout />,
  children: [
    { path: '', element: <Dashboard /> },
    { path: 'dashboard', element: <Dashboard /> },
    { path: 'token', element: <Token /> },
    { path: 'log', element: <Log /> },
    { path: 'pricing', element: <UserPricing /> },
    { path: 'voices', element: <SystemVoices /> },
    { path: 'topup', element: <Topup /> },
    { path: 'profile', element: <Profile /> },
    { path: '404', element: <NotFoundView /> }
  ]
};

export default [PanelRoutes];
